const promoCodeMixin = {
  computed: {
    browseProductsButtonEnabled () {
      return this.isValidBrowseProductsLinkUrl &&
             this.isBrowseProductsLinkExists() &&
             this.requestFromCarousel()
    },
    browseProductsPath () {
      const url = this.promoCodeBrowseProductsUrl()
      return url.pathname
    },
    browseProductsUrl () {
      const url = this.promoCodeBrowseProductsUrl()
      return url.href
    },
    isBrowseProductsLinkToExternal () {
      return !(this.browseProductsPath === `/offers/${this.promoCodeSlug()}`)
    },
    isValidBrowseProductsLinkUrl () {
      try {
        return Boolean(this.promoCodeBrowseProductsUrl())
      } catch (e) {
        if (e.constructor.name === 'TypeError') {
          return false
        } else {
          throw e
        }
      }
    }
  },
  methods: {
    promoCodeAttributes () {
      return this.promoCode ? this.promoCode.attributes : this.promoCodeAttrs
    },
    promoCodeSlug () {
      return this.promoCodeAttributes().slug
    },
    promoCodeBrowseProductLink () {
      return this.promoCodeAttributes()['browse-products-web-link']
    },
    promoCodeBrowseProductsUrl () {
      return new URL(this.promoCodeBrowseProductLink())
    },
    isBrowseProductsLinkExists () {
      return (this.promoCodeBrowseProductLink() !== null)
    }
  }
}

export {
  promoCodeMixin
}
